import { useI18n } from '../../contexts/I18nContext';
import { dateKeyOf, fromDateKey } from '../../lib/calendarDates';
import type { Task } from '../../lib/tasksApi';
import { toDueISO } from '../tasks/linear/dueDate';
import { useToast } from '../tasks/linear/Toast';
import { useOptimisticTaskUpdate } from '../tasks/linear/useOptimisticTaskUpdate';

/**
 * Sets a task's due date to the day it was dropped on. Optimistic like the
 * inline editors, so the chip stays where it landed; if the server refuses, it
 * goes back and a toast says why it moved again.
 */
export function useMoveTaskToDay() {
  const update = useOptimisticTaskUpdate();
  const toast = useToast();
  const { t } = useI18n();

  return (task: Task, dayKey: string) => {
    if (task.dueDate && dateKeyOf(task.dueDate) === dayKey) return;
    const dueDate = toDueISO(fromDateKey(dayKey));
    update.mutate(
      { id: task.id, input: { dueDate }, patch: (current) => ({ ...current, dueDate }) },
      { onError: () => toast.show(t('calendar.moveFailed')) },
    );
  };
}
